<template>
    <v-navigation-drawer
      permanent
      fixed
      dark
      mini-variant
      mini-variant-width="56"
      :color="enterpriseColor"
      app
    >
      <template v-slot:prepend>
        <v-list>
          <v-list-item
            @click="handleGoTo('/dashboard')"
          >
            <v-list-item-avatar
              tile
            >
              <v-img :src="require('@/assets/logo.png')"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="title">Dviewconnect</v-list-item-title>
            </v-list-item-content>
            <!-- <v-list-item-action>
              <v-icon>mdi-menu-down</v-icon>
            </v-list-item-action> -->
          </v-list-item>
        </v-list>
      </template>

      <v-divider></v-divider>
      <v-list
        nav
        dense
      >
        <v-list-item
          bottom
          v-for="(item, index) in menu"
          :key="`mnu${index}`"
          :class="item.admin ? 'admin' : 'normal'"
          link
          @click="handleGoTo(item.rute)"
        >
          <!-- <v-list-item-icon>
            <v-icon :class="item.admin ? 'admin' : 'normal'">{{ item.icon }}</v-icon>
          </v-list-item-icon> -->
          <v-list-item-icon>
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-icon :class="item.admin ? 'admin' : 'normal'" v-on="on">{{ item.icon }}</v-icon>
              </template>
              <span>{{ $t(item.title) }}</span>
            </v-tooltip>
          </v-list-item-icon>
          <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
        </v-list-item>
      </v-list>
      <!-- <template v-slot:append>
        <div>
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-btn
                block
                text
                @click="handleGoTo('/share')"
              >
                <v-icon>mdi-share-variant</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('share.title') }}</span>
          </v-tooltip>
        </div>
      </template> -->
    </v-navigation-drawer>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import constants from '@/constants'
  import api from '@/services/api'
  import utils from '@/services/utils'
  export default {
    data: () => ({
      menu: constants.menus.filter(x => !x.admin),
      color: 'red'
    }),
    computed: {
      ...mapState('app',['enterpriseColor','enterpriseID']),
    },
    // watch: {
    //   enterpriseColor: {
    //     handler: function (newValue) {
    //       console.log('bvv', newValue)
    //       this.color = newValue
    //     },
    //     deep: true
    //   }
    // },
    mounted () {
      api.getItem('users', true, utils.getUserID()).then(response => {
        if (response.Role === constants.roles.admin) this.menu = constants.menus
      })
    },
    methods: {
      handleGoTo (rute) {
        // if (rute === '/common-menus') {   
        //   const id = '72c0948f-7eef-4d82-ab84-f94862c7a37f'       
        //   api.getItem('enterprises', true, id).then(response => {
        //     utils.setActiveEnterprise(this, response)
        //     this.$router.push(rute)
        //   })
        // } else {
          this.$router.push(rute)
        // }
      }
    }
  }
</script>

<style lang="scss">
  .admin {
    color: red !important;
  }
  .normal {
    color: white !important;
  }
  .v-list-item--disabled {
    opacity: 0.1;
  }
</style>
